import { computed } from '@ember/object';
import { isNone } from '@ember/utils';
import { fragment } from 'ember-data-model-fragments/attributes';
import { attr } from '@ember-data/model';
import { getFormat } from '@square/dashboard-utilities/utils/i18n-deprecated/format';
import EmberDataBaseFragment from '@square/dashboard-data/models/ember-data-base-fragment';
import Money from '@square/dashboard-money/models/money';
export default EmberDataBaseFragment.extend({
  equals(other) {
    if (isNone(other)) {
      return false;
    }
    return this.discountBasisPoints === other.get('discountBasisPoints') && this.interchangeCents && this.interchangeCents.equals(other.get('interchangeCents'));
  },
  discountBasisPoints: attr('number'),
  interchangeCents: attr('money-proto'),
  constraints: attr('array', {
    defaultValue: () => []
  }),
  costPlusFeeRate: fragment('cost-plus-processing-fee'),
  interchangePlusFeeRate: fragment('interchange-plus-processing-fee'),
  feePlanId: attr('string'),
  formatted: computed('discountBasisPoints', 'interchangeCents', function () {
    return this.formatRate(this.discountBasisPoints, this.interchangeCents);
  }),
  formattedCostPlusRate: computed('costPlusFeeRate.{marginBasisPoints,marginCents}', function () {
    return this.formatRate(this.costPlusFeeRate?.marginBasisPoints, this.costPlusFeeRate?.marginCents);
  }),
  formattedInterchangePlusRate: computed('interchangePlusFeeRate.{marginBasisPoints,marginCents}', function () {
    return this.formatRate(this.interchangePlusFeeRate?.marginBasisPoints, this.interchangePlusFeeRate?.marginCents);
  }),
  formattedConstraints: computed('constraints.@each.{amountBaseUnit,type}', function () {
    return this.constraints.reduce((formattedConstraints, constraint) => {
      // eslint-disable-next-line no-param-reassign
      formattedConstraints[constraint.type] = this.formatCurrency(constraint.amount_base_unit);
      return formattedConstraints;
    }, {});
  }),
  formatCurrency(amount, currencyCode) {
    const amountMoney = Money.fromCents(amount, currencyCode);
    return getFormat().currency(amountMoney.get('amount'), amountMoney.get('currencyCode'), {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    });
  },
  formatRate(basisPoints, cents) {
    if (!basisPoints && !cents) {
      return null;
    }
    if (basisPoints === 0 && cents.get('amount') === 0) {
      return getFormat().percent(basisPoints / 100);
    }
    let variable = '';
    if (basisPoints) {
      const options = {
        minimumFractionDigits: basisPoints < 100 ? 2 : 1,
        maximumFractionDigits: 2
      };
      variable = getFormat().percent(basisPoints / 100, options);
    }
    let fixed = '';
    if (cents.get('amount')) {
      fixed = getFormat().currencyCent(cents.get('amount'), cents.get('currencyCode'));
    }
    const separator = fixed && variable ? ' + ' : '';
    return variable + separator + fixed;
  }
}).reopenClass({
  _modelNameForMigration: 'processing-fee'
});